 export class Attendee{
    isNewlyAdded: boolean;
    eventtitle: string;
    eventid: string;
    name: string;
    phone: string;
    code = "1234";
    email: string;
}

export class AttendeeList{
    attendees: Attendee[];
    eventid: string;
    okphones: string;
    addUnique(att: Attendee){
    let found = false;
        //allow duplicate phones for testing
        /*
            this.attendees.forEach((element) => {
                if(element.phone == att.phone){
                    found = true;
                    element.name = att.name;
                    return;
                }
            });
        */

        if(!found){
            this.attendees.push(att);
        }
    }
}